import React, { Fragment } from "react";
import "./footer.scss";
import logo from "../../assests/images/blume.png";
import { Link } from "react-router-dom";
import useUTMParams from "../../hooks/utmParams";
const Footer = () => {
  const utmQuery = useUTMParams();
  return (
    <Fragment>
      <div className="footer">
        <div className="container1500">
          <div className="footer-info">
            <Link to={`/${utmQuery}`} onClick={() => window.scrollTo(0, 0)}>
              <img className="logo" src={logo} alt="logo" />
            </Link>
            <div className="policies">
              <p>
                <a
                  href="https://docs.google.com/document/d/e/2PACX-1vR8s044oOHtVXZgop3aatLvgLgWxnNrsvOtHtCrTLIkxc5dr-P4ybqoDw2JohtEhl8WqJN2yoG-aPVx/pub"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
              </p>
              <p>
                <a
                  href="https://docs.google.com/document/d/e/2PACX-1vTabMjZy8f2h6rEbZul0e2c9zPuqBnHE2rWgmWwXnsvLBU8Xz7THdoGXvFU8K-SqzM5oNarjOJ9lGIK/pub"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Terms & Conditions
                </a>
              </p>
              <p>
                <a
                  href="https://docs.google.com/document/d/e/2PACX-1vSHn-XEDtt41doHaIP7l9RbyJXZ2WYRTVQgoSPHtUUjUcylJz3fUnC9p99nVDxU7iazeEKfxHfmj2nz/pub"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Complaint Procedure
                </a>
              </p>
              <p>
                <a
                  href="https://docs.google.com/document/d/e/2PACX-1vRG6c_boKssyLcYAMzW-q2rNA8gqLS92LBOL2ZZ-KKeElpWgwlXamHOCkmYgb-31aY2evSmfVxOFvOv/pub"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Cookie Policy
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-info-mob">
        <div className="mob-link">
          <span>
            <a
              href="https://docs.google.com/document/d/e/2PACX-1vR8s044oOHtVXZgop3aatLvgLgWxnNrsvOtHtCrTLIkxc5dr-P4ybqoDw2JohtEhl8WqJN2yoG-aPVx/pub"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </span>
          <span>&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;</span>
          <span>
            <a
              href="https://docs.google.com/document/d/e/2PACX-1vTabMjZy8f2h6rEbZul0e2c9zPuqBnHE2rWgmWwXnsvLBU8Xz7THdoGXvFU8K-SqzM5oNarjOJ9lGIK/pub"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms & Conditions
            </a>
          </span>
          <span>&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;</span>
          <span>
            <a
              href="https://docs.google.com/document/d/e/2PACX-1vSHn-XEDtt41doHaIP7l9RbyJXZ2WYRTVQgoSPHtUUjUcylJz3fUnC9p99nVDxU7iazeEKfxHfmj2nz/pub"
              target="_blank"
              rel="noopener noreferrer"
            >
              Complaint Procedure
            </a>
          </span>
          <span>&nbsp;&nbsp;&nbsp;-&nbsp;&nbsp;&nbsp;</span>
          <span>
            <a
              href="https://docs.google.com/document/d/e/2PACX-1vRG6c_boKssyLcYAMzW-q2rNA8gqLS92LBOL2ZZ-KKeElpWgwlXamHOCkmYgb-31aY2evSmfVxOFvOv/pub"
              target="_blank"
              rel="noopener noreferrer"
            >
              Cookie Policy
            </a>
          </span>
        </div>
      </div>
    </Fragment>
  );
};

export default Footer;
